import React, { useState, useRef, useEffect } from "react";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

const TabItem = ({ label, link, className, NavLink }) => {
  return (
    <NavLink
      to={link}
      className={({ isActive }) =>
        `${className} ${
          isActive
            ? "text-background/90 bg-secondary font-medium"
            : "text-secondary/80 hover:scale-[.98] hover:bg-secondary/10"
        } text-subtitle2 font-ptsans py-2 px-4 items-center rounded-[10px] transition flex-grow-0 flex-shrink-0`
      }
    >
      {label}
    </NavLink>
  );
};

const Tab = ({ tabs, className, tabButtonClassName, NavLink }) => {
  const tabContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  // Check if scrolling is possible
  const updateScrollState = () => {
    if (tabContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = tabContainerRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
    }
  };

  useEffect(() => {
    updateScrollState();
    const handleResize = () => updateScrollState();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll function
  const scrollTabs = (direction) => {
    if (!tabContainerRef.current) return;
    const scrollAmount = 150;
    tabContainerRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <div className="absolute top-1 left-0 w-full lg:w-fit flex items-center z-50">
      {/* Left Gradient + Scroll Button */}
      {canScrollLeft && (
        <div className="absolute left-0 z-10 h-full flex items-center">
          <button
            onClick={() => scrollTabs("left")}
            className="absolute left-0 z-10 h-full px-2 border-l border-y border-secondary/5 bg-gradient-to-r from-background_2 rounded-l-xl via-background_2/80 to-transparent 
          flex items-center justify-center text-secondary hover:text-secondary/80 transition"
          >
            <IoChevronBack className="w-5 h-5" />
          </button>
        </div>
      )}

      {/* Tab Container */}
      <div
        ref={tabContainerRef}
        className={`flex gap-2 border-b bg-background_2 border border-secondary/15 p-1 rounded-xl drop-shadow-md w-full justify-start items-center overflow-x-auto no-scrollbar scroll-smooth ${className}`}
        onScroll={updateScrollState}
      >
        {tabs.map((tab) => (
          <TabItem
            key={tab.label}
            label={tab.label}
            link={tab.link}
            className={tabButtonClassName}
            NavLink={NavLink}
          />
        ))}
      </div>

      {/* Right Gradient + Scroll Button */}
      {canScrollRight && (
        <div className="absolute right-0 z-10 h-full flex items-center ">
          <button
            onClick={() => scrollTabs("right")}
            className="absolute right-0 z-10 h-full px-2 border-r border-y border-secondary/5 bg-gradient-to-l from-background_2 rounded-r-xl via-background_2/80 to-transparent 
          flex items-center justify-center text-secondary hover:text-secondary/80 transition"
          >
            <IoChevronForward className="w-5 h-5" />
          </button>
        </div>
      )}
    </div>
  );
};

export default Tab;
